import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import { canAccessPage, getUserPermissions } from './utils/permissions';
import './App.css';
import LoginPage from './pages/group/pages/LoginPage';
import GroupList from './pages/group/pages/GroupList';
import UserChat from './pages/group/pages/Userchat/userchat';

function App() {
  const permissions = getUserPermissions();

  const ProtectedRoute = ({ element, page }) => {
    if (!canAccessPage(page, permissions)) {
      return <Navigate to="/number" replace />;
    }

    return element;
  };

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/group/login" element={<ProtectedRoute element={<LoginPage />} />} />
        <Route path="/group/grouplist" element={<ProtectedRoute element={<GroupList />} />} />
        <Route path="/group/userchat" element={<ProtectedRoute element={<UserChat />} />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
